import { cva } from "class-variance-authority";

/** Shared visual variants used by buttons and button-like links. */
export const buttonVariants = cva(
  "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors outline-none disabled:pointer-events-none disabled:opacity-50 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground hover:bg-brand-hover shadow-xs",
        /** Signature Kayer brand blue action button */
        brand:
          "bg-brand text-white hover:bg-brand-hover shadow-xs rounded-button font-bold",
        /** Amber/gold action button used in OTP flows and highlights */
        amber:
          "bg-amber-gold text-slate-dark hover:bg-amber-hover shadow-xs rounded-button font-bold",
        /** Golden button matching Flutter DetailPillButton style */
        gold: "bg-amber-pill text-[#1E2129] hover:bg-[#E5A515] shadow-xs rounded-full font-bold",
        /** Compact pill button matching Flutter DetailPillButton */
        pill: "rounded-full bg-amber-pill text-[#1E2129] hover:bg-[#E5A515] font-bold text-xs px-4 py-1 shadow-none",
        /** Secondary outline pill button */
        pillOutline:
          "rounded-full border border-border bg-white text-slate-muted hover:bg-brand-subtle hover:text-brand font-bold text-xs px-4 py-1 shadow-none",
        /** Navigation tab/button matching Flutter NavButton */
        nav: "rounded-button bg-brand-light text-kayer-grey hover:bg-[#BACFEF] font-bold text-xs shadow-none",
        /** Brand-colored outline button */
        outlineBrand:
          "border border-brand text-brand hover:bg-brand-subtle rounded-button font-semibold",
        destructive:
          "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
        outline:
          "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        /** 44px - 46px mobile touch target button matching Flutter _LoginButton */
        touch: "h-11 sm:h-11.5 px-5 text-sm sm:text-base rounded-button",
        /** 32px compact pill height */
        pill: "h-8 px-4 text-xs rounded-full",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
